export default {
  name: 'advanced-settings',
  props: {
    signedInUser: Object
  }
}
